module.exports = __webpack_public_path__ + "img/DE06242.c973e09c.png";